( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( window ).width() > 1024 ) {
        // ADA close menu when focus shifts outside of it
        $( '.navigation-one .primary-navigation__panels' ).on( 'focusout', function( e ) {
          const $menuItem = $( this );
          const newFocus = e.relatedTarget;
          if ( newFocus === null ) return;
          if ( !$menuItem.has( newFocus ).length ) {
            const $trigger = $menuItem.find( '.primary-menu-item__link.is-open' );
            if ( $trigger.length ) {
              $trigger.trigger( 'click' );
              newFocus.focus();
            }
          }
        } );
      }

      const $mobileCta = $( '#mobile-primary-cta-bar' );
      if ( $mobileCta.length ) {
        const updateMobileCtaHeight = () => {
          const height = $mobileCta.is( ':visible' ) ? ( $mobileCta.outerHeight() || 0 ) : 0;
          $( ':root' ).css( '--mobileCtaHeight', `${height}px` );
        };
        updateMobileCtaHeight();
        const resizeThrottle = new app.components.common.Throttle( updateMobileCtaHeight, 250 );
        $( window ).on( 'resize', () => resizeThrottle.run() );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'navigation-one', COMPONENT );
} )( app );
